module.exports = __webpack_public_path__ + "img/casa-cody-background.9db55a66.jpeg";